:host {
  display: flex;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
:host ::slotted(.gutter-horizontal),
:host ::slotted(.gutter-vertical) {
  transition: background-color 0.25s;
  background-color: var(--gray-01);
}
:host ::slotted(.gutter-horizontal) {
  height: 100%;
  float: left;
  cursor: col-resize;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
:host ::slotted(.gutter-horizontal):after {
  right: -5px;
}
:host ::slotted(.gutter-horizontal):before {
  left: -5px;
}
:host ::slotted(.gutter-vertical) {
  cursor: row-resize;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--gray-01);
  position: relative;
}
:host ::slotted(.gutter-vertical):after {
  right: 50%;
  transform: rotate(90deg) translateX(6px) translateY(-2px);
}
:host ::slotted(.gutter-vertical):before {
  left: 50%;
  transform: rotate(90deg) translateX(-6px) translateY(2px);
}

:host([direction=vertical]) {
  flex-direction: column;
}

:host([knob=bidirectional]) ::slotted(.gutter-horizontal):after, :host([knob=bidirectional]) ::slotted(.gutter-horizontal):before,
:host([knob=bidirectional]) ::slotted(.gutter-vertical):after,
:host([knob=bidirectional]) ::slotted(.gutter-vertical):before {
  content: "";
  width: 0;
  height: 0;
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  z-index: 10;
  position: relative;
  pointer-events: none;
  opacity: 0;
  pointer-events: none;
  transition: 0.25s all;
}
:host([knob=bidirectional]) ::slotted(.gutter-horizontal):after,
:host([knob=bidirectional]) ::slotted(.gutter-vertical):after {
  border-left: 3px solid var(--gray-03);
}
:host([knob=bidirectional]) ::slotted(.gutter-horizontal):before,
:host([knob=bidirectional]) ::slotted(.gutter-vertical):before {
  border-right: 3px solid var(--gray-03);
}

:host([knob=bidirectional]) ::slotted(.gutter-horizontal):after {
  bottom: -19px;
  right: 1px;
}
:host([knob=bidirectional]) ::slotted(.gutter-horizontal):before {
  top: -19px;
  left: 1px;
}

:host([knob=bidirectional]) ::slotted(.gutter-vertical):after {
  bottom: 6px;
  right: 23px;
}
:host([knob=bidirectional]) ::slotted(.gutter-vertical):before {
  top: 6px;
  left: 24px;
}

:host([knob=bidirectional]) ::slotted(.gutter-horizontal:hover):after,
:host([knob=bidirectional]) ::slotted(.gutter-vertical:hover):after {
  opacity: 1;
}
:host([knob=bidirectional]) ::slotted(.gutter-horizontal:hover):before,
:host([knob=bidirectional]) ::slotted(.gutter-vertical:hover):before {
  opacity: 1;
}

:host(.knob-left-hover) ::slotted(.gutter-horizontal):before,
:host(.knob-left-hover) ::slotted(.gutter-vertical):before {
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 3px solid var(--color-primary-hover);
}

:host(.knob-right-hover) ::slotted(.gutter-horizontal):after,
:host(.knob-right-hover) ::slotted(.gutter-vertical):after {
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 3px solid var(--color-primary-hover);
}

:host(.left-collapsed-to-zero) ::slotted(.gutter),
:host(.right-collapsed-to-zero) ::slotted(.gutter) {
  pointer-events: none;
}

:host(.collapsed-to-zero) ::slotted(.knob) {
  pointer-events: auto;
}

:host(.left-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-horizontal):before,
:host(.left-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-vertical):before {
  opacity: 0;
  pointer-events: none;
}

:host(.left-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-horizontal):after,
:host(.left-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-vertical):after {
  opacity: 1;
}

:host(.left-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-horizontal):after {
  bottom: 0;
}

:host(.left-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-vertical):after {
  right: 3px;
}

:host(.right-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-horizontal):after,
:host(.right-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-vertical):after {
  opacity: 0;
  pointer-events: none;
}

:host(.right-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-horizontal):before,
:host(.right-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-vertical):before {
  opacity: 1;
}

:host(.right-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-horizontal):before {
  top: 0;
}

:host(.right-collapsed-to-zero[knob=bidirectional]) ::slotted(.gutter-vertical):before {
  left: 3px;
}

:host(.gutter-reached-right[knob=bidirectional]) ::slotted(.gutter-horizontal):after,
:host(.gutter-reached-right[knob=bidirectional]) ::slotted(.gutter-vertical):after {
  opacity: 0;
  pointer-events: none;
}

:host(.gutter-reached-left[knob=bidirectional]) ::slotted(.gutter-horizontal):before,
:host(.gutter-reached-left[knob=bidirectional]) ::slotted(.gutter-vertical):before {
  opacity: 0;
  pointer-events: none;
}

:host(.dragging) ::slotted(.gutter-horizontal),
:host(.dragging) ::slotted(.gutter-vertical) {
  background-color: var(--color-primary-hover);
}
:host(.dragging) ::slotted(.gutter-horizontal):after,
:host(.dragging) ::slotted(.gutter-vertical):after {
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-left: 3px solid var(--color-on-primary);
}
:host(.dragging) ::slotted(.gutter-horizontal):before,
:host(.dragging) ::slotted(.gutter-vertical):before {
  border-top: 4px solid transparent;
  border-bottom: 4px solid transparent;
  border-right: 3px solid var(--color-on-primary);
}
:host(.dragging) ::slotted(.gutter-horizontal) .middle-line,
:host(.dragging) ::slotted(.gutter-vertical) .middle-line {
  background-color: red;
}